export default {
  message: "",
  errors: [],
  success: false,
  forget_phone: undefined,
  loggedIn: !!localStorage.userData,
};
